import ajax, { isHttpError, isNetworkError } from "../../authenticationSafeAjax";

export function fetchDisclosureData(url, entityName, callback) {
    ajax({ url: url }, (statusCode, responseBody) => {
        let response;

        if (statusCode == 404) {
            response = { failed: { canRetry: true, errors: ["Unable to fetch " + entityName + " as they are not yet available."] } };
        } else if (isHttpError(statusCode)) {
            response = { failed: { canRetry: false, errors: ["Unable to fetch " + entityName + " due to an unexpected error."] } };
        } else if (isNetworkError(statusCode)) {
            response = { failed: { canRetry: true, errors: ["Unable to fetch " + entityName + " due to connectivity issues. Please try again."] } };
        } else {
            var responseData = JSON.parse(responseBody);
            response = Object.assign({}, responseData, { failed: null });
        }

        callback(response);
    });
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/server/fetchDisclosureData.js
 **/